// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 解决移动端3s延迟
import FastClick from 'fastclick'
import router from './router'
import './assets/js/resize'
/** vant引用 **/
import Vant from 'vant'
import 'vant/lib/index.css'
import '../src/assets/css/common.css'
import '../src/assets/css/normalize.css'
/** echarts引用 **/
import echarts from 'echarts'
import VueCookie from 'vue-cookie'
/** axios **/
import axios from '@/assets/js/axios'
import store from '@/store/index'
/**  单独引用cube-ui解决下拉选项picker问题 **/
import {
  // 基础样式
  Style,
  // basic
  Loading,
  Popup,
  Picker,
  Scroll,
  IndexList,
  Swipe
} from 'cube-ui'
/** 引入全部组件 **/
Vue.use(Style)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Scroll)
Vue.use(Swipe)
Vue.use(IndexList)
Vue.prototype.axios = axios
Vue.use(axios.plugin)

FastClick.attach(document.body)
Vue.use(Vant)
Vue.use(VueCookie)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
router.beforeEach((to, from, next) => {
  setTimeout(() => {
    window.scrollTo(0, 0)
    document.body.scrollTop = 0
  })
  next()
})
function getIsWxClient () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  }
  return false
}
Vue.prototype.isMiniProgram = function (callback) { // 是否为小程序环境
  // 是否在微信环境
  if (!getIsWxClient()) {
    callback(false)
  } else {
    // 微信API获取当前运行环境
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) { // 小程序环境
        callback(true)
      } else {
        callback(false)
      }
    })
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  http: axios.plugin,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js